export const homePath = '/';
export const publicPhotosIndexPath = '/photos';
